import { gql } from '@apollo/client';
import {
  SubjectFragment,
  UserAliasReplacementFieldsFragment,
} from '../../../../utils/apollo/fragments';
import {
  FunnelCohortAnalysisQueryFragment,
  RetentionCohortAnalysisQueryFragment,
} from '../../../../utils/apollo/cohorts';

const SearchCohortEntityFragment = gql`
  fragment SearchCohortEntityFields on Analysis {
    id
    display
    start
    end
    query {
      ... on FunnelQuery {
        subject {
          ...SubjectFields
        }
        ...FunnelCohortAnalysisQueryFields
      }
      ... on RetentionQuery {
        ...RetentionCohortAnalysisQueryFields
      }
    }
    pref {
      aliasReplacements {
        ...UserAliasReplacementFields
      }
    }
  }
  ${SubjectFragment}
  ${FunnelCohortAnalysisQueryFragment}
  ${RetentionCohortAnalysisQueryFragment}
  ${UserAliasReplacementFieldsFragment}
`;

export const SEARCH_COHORT_ANALYSES = gql`
  query SearchCohortAnalyses(
    $term: String
    $schemaIds: [ID!]
    $queryTypes: [QueryType!]
    $kind: AnalysisKind
    $userOnly: Boolean
    $statuses: [AnalysisStatus]
    $pagination: Pagination!
    $includes: [ID!]!
    $filter: AnalysisFilter
  ) {
    searchAnalysis(
      term: $term
      schemaIds: $schemaIds
      queryTypes: $queryTypes
      kind: $kind
      userOnly: $userOnly
      statuses: $statuses
      pagination: $pagination
      includes: $includes
      filter: $filter
    ) {
      entities {
        ...SearchCohortEntityFields
      }
    }
  }
  ${SearchCohortEntityFragment}
`;
